import { useState } from "react";
import Timeline from "@/components/workflow/Timeline";
import Comments from "@/components/workflow/Comments";

export default function TabContainer({ tabs }) {
	const [activeTab, setActiveTab] = useState("application_tracker");

	const renderTabContent = () => {
		switch (activeTab) {
      case "application_tracker":
				return <Timeline />;
			case "comments":
				return <Comments />;
			default:
				return null;
		}
	};

	return (
		<>
			<div className="border border-[#3F5064] bg-accentBg p-4 rounded-[6px] mb-[50px] ">
				<div className="flex gap-8 mb-6 border-b border-gray-700">
					{tabs.map((tab) => (
						<button
							type="button"
							key={tab.id}
							onClick={() => setActiveTab(tab.id)}
							className={`px-4 py-2 text-sm transition-colors ${
								activeTab === tab.id
									? "text-primaryGreen border-b-2 border-primaryGreen"
									: "text-textAccentColor hover:text-gray-300"
							}`}
						>
							<span className="uppercase">{tab.label}</span>
						</button>
					))}
				</div>
				{renderTabContent()}
			</div>
		</>
	);
}
